<div class="destinations__form-card surface-card">
  <div class="destinations__form-header">
    <div>
      <h2>{{ formTitleKey | translate }}</h2>
      <p>{{ 'destinations.form.description' | translate }}</p>
    </div>
    <button type="button" class="ghost-btn compact" (click)="cancel()" aria-label="{{ 'destinations.actions.close' | translate }}">×</button>
  </div>

  <form class="destinations__form" [formGroup]="destinationForm" (ngSubmit)="submit()">
    <div class="destinations__form-field" *ngIf="hasGlobalDataScope">
      <span>Owner</span>
      <app-custom-select
        formControlName="ownerEntitySelect"
        [options]="ownerEntityOptions"
        placeholder="Seleziona un'entità">
      </app-custom-select>
      <small class="field-error"
             *ngIf="destinationForm.get('ownerEntitySelect')?.invalid && destinationForm.get('ownerEntitySelect')?.touched">
        Seleziona un owner
      </small>
    </div>

    <div class="destinations__type-info" *ngIf="selectedDestinationType">
      <div>
        <label>{{ 'destinations.form.typeLabel' | translate }}</label>
        <p>{{ selectedDestinationType.Description || selectedDestinationType.Name }}</p>
      </div>
      <div>
        <label>{{ 'destinations.form.activationLabel' | translate }}</label>
        <p>{{ selectedDestinationType.ActivationType || '—' }}</p>
      </div>
      <div>
        <label>{{ 'destinations.form.connectorLabel' | translate }}</label>
        <p>{{ getConnectorLabel(selectedDestinationType.ConnectorType) }}</p>
      </div>
    </div>

    <label class="destinations__form-field">
      <span>{{ 'destinations.form.name' | translate }}</span>
      <input type="text" formControlName="name">
    </label>

    <label class="destinations__form-field">
      <span>{{ 'destinations.form.destinationType' | translate }}</span>
      <app-custom-select
        formControlName="destinationTypeId"
        [options]="destinationTypeOptions"
        [placeholder]="'destinations.form.select' | translate">
      </app-custom-select>
    </label>

    <ng-container *ngIf="selectedDestinationType; else noTypeSelected">
      <label class="destinations__form-field">
        <span>{{ 'destinations.form.connectionParams' | translate }}</span>
        <ng-container *ngIf="hasDynamicConnectionFields && connectionForm; else fallbackParams">
        <div class="destinations__connection-fields" [formGroup]="connectionForm">
          <div class="destinations__connection-field" *ngFor="let field of connectionFieldDefs">
            <label>
              {{ getFieldLabel(field) }}
              <span aria-hidden="true" *ngIf="field.required">*</span>
            </label>
            <ng-container [ngSwitch]="field.type">
              <textarea *ngSwitchCase="'textarea'"
                        [formControlName]="field.key"
                        rows="3"
                        [placeholder]="getFieldPlaceholder(field) || ''"></textarea>
              <input *ngSwitchCase="'password'"
                     type="password"
                     [formControlName]="field.key"
                     [placeholder]="getFieldPlaceholder(field) || ''">
              <input *ngSwitchCase="'number'"
                     type="number"
                     [formControlName]="field.key"
                     [placeholder]="getFieldPlaceholder(field) || ''">
              <input *ngSwitchDefault
                     type="text"
                     [formControlName]="field.key"
                     [placeholder]="getFieldPlaceholder(field) || ''">
            </ng-container>
            <div class="destinations__file-upload" *ngIf="field.key === 'JsonCredentials'">
              <label class="upload-btn">
                <input type="file" (change)="onJsonFileSelected($event, field)" accept=".json,.txt,.pem,.key">
                {{ 'destinations.form.uploadJson' | translate }}
              </label>
            </div>
          </div>
        </div>
        <small>{{ 'destinations.form.connectionFieldsHint' | translate }}</small>
      </ng-container>
      <ng-template #fallbackParams>
        <textarea formControlName="connectionParams" rows="6"></textarea>
        <small>{{ 'destinations.form.connectionHint' | translate }}</small>
      </ng-template>
      </label>
    </ng-container>
    <ng-template #noTypeSelected>
      <p class="destinations__select-hint">{{ 'destinations.form.selectTypeHint' | translate }}</p>
    </ng-template>

    <label class="destinations__form-field destinations__form-field--inline">
      <input type="checkbox" formControlName="active">
      <span>{{ 'destinations.form.active' | translate }}</span>
    </label>

    <div class="destinations__form-actions">
      <button type="button" class="ghost-btn" (click)="cancel()">{{ 'destinations.actions.cancel' | translate }}</button>
      <button type="submit" class="primary-btn" [disabled]="saving">
        {{ saving ? ('destinations.states.saving' | translate) : ('destinations.actions.save' | translate) }}
      </button>
    </div>
  </form>
</div>
